module.exports = __webpack_public_path__ + "static/media/bannerimg05.a0d9cb41.jpg";